/* eslint-disable */
/**
 * Trust All Scripts
 *
 * This is a dirty little script for iterating over script tags
 * of your Ghost posts and adding them to the document head.
 *
 * This works for any script that then injects content into the page
 * via ids/classnames etc.
 *
 */
// const { datadogRum } = require('@datadog/browser-rum')
// const $ = require('jquery')
const axios = require('axios')
const { IsMobileProvider } = require('./src/context/isMobileContextApi')

const loadDelayedScripts = () => {
    let headerStickHandler = null;

    const customScripts = () => {
        let popupRequestdemo = localStorage.getItem('showMsg');
        if (popupRequestdemo === 'false') {
            const footerb = document.getElementById('footerb');
            if (footerb) footerb.classList.remove('popupspc');
        }

        document.querySelectorAll('.mobile_listing').forEach(el => {
            el.addEventListener('click', () => {
                const menu = el.querySelector('.dropdownmenu');
                if (menu) menu.classList.toggle('mobileMenuD');
            });
        });

        document.querySelectorAll('.listingMenu > a').forEach(a => {
            a.addEventListener('click', event => event.preventDefault());
        });

        if (headerStickHandler) {
            window.removeEventListener('scroll', headerStickHandler);
        }
        const headerStick = document.querySelector('.header_stick');
        if (headerStick) {
            headerStickHandler = () => {
                if (window.scrollY > 0) {
                    headerStick.classList.add('navbar_fixed');
                } else {
                    headerStick.classList.remove('navbar_fixed');
                }
            };
            window.addEventListener('scroll', headerStickHandler, { passive: true });
        }

        document.querySelectorAll('nav .navbar-nav a').forEach(a => {
            if (a.href === window.location.href) {
                a.classList.add('active');
            }
        });

        document.querySelectorAll('.mobileheader_menu li a').forEach(a => {
            a.addEventListener('click', () => {
                const collapse = document.querySelector('.mobile_navbar .navbar-collapse');
                if (collapse) collapse.classList.toggle('show');
            });
        });

        document.querySelectorAll('.scrollToDownload').forEach(el => {
            el.addEventListener('click', e => {
                e.preventDefault();
                const href = el.getAttribute('href');
                const target = document.querySelector(href);
                if (target) {
                    const offset = target.getBoundingClientRect().top + window.pageYOffset - 130;
                    window.scrollTo({ top: offset, behavior: 'smooth' });
                }
            });
        });

        document.querySelectorAll('.scrollto').forEach(el => {
            el.addEventListener('click', e => {
                e.preventDefault();
                const href = el.getAttribute('href');
                const target = document.querySelector(href);
                if (target) {
                    const offset = target.getBoundingClientRect().top + window.pageYOffset - 250;
                    window.scrollTo({ top: offset, behavior: 'smooth' });
                }
            });
        });
    };

    const setupExitPopup = () => {
        const hide = (selector) => {
            document.querySelectorAll(selector).forEach(el => el.style.display = 'none');
        };
        const show = (selector, display = 'block') => {
            document.querySelectorAll(selector).forEach(el => el.style.display = display);
        };

        const leaveFromTop = (e) => {
            if (e.clientY < 0) {
                const showExitPopup = sessionStorage.getItem('showExitPopup');
                if (showExitPopup !== 'false') {
                    show('#ouibounce-modal');
                    show('#ouibounce-modal .modal');
                }
                const closeBtn = document.querySelector('#ouibounce-modal .close .cross');
                if (closeBtn) {
                    closeBtn.addEventListener('click', () => {
                        hide('#ouibounce-modal .modal');
                        sessionStorage.setItem('showExitPopup', 'false');
                        hide('.underlay');
                        hide('#ouibounce-modal');
                    });
                }
                if (showExitPopup === 'false') {
                    hide('#ouibounce-modal .modal');
                    hide('.underlay');
                    hide('#ouibounce-modal');
                }
            }
        };

        document.addEventListener('mouseleave', leaveFromTop);
        hide('#ouibounce-modal .modal');
    };

    customScripts();
    setupExitPopup();
};

exports.onRouteUpdate = () => {
    // Defer non-critical scripts
    setTimeout(loadDelayedScripts, 1500);
};

//add  revenueHero script
const { 
  initPerformanceOptimizations, 
  loadGTMOptimized, 
  checkCountryOptimized 
} = require('./src/utils/thirdPartyOptimizer');

exports.onClientEntry = () => {
  const events = ['scroll', 'mousedown', 'touchstart', 'keydown'];
  const loadThirdPartyScripts = () => {
    initPerformanceOptimizations();
    checkCountryOptimized().then((country) => {
      let allowCookie = false
      let showConsentBar = true
      let storedState = JSON.parse(localStorage.getItem('cookieConsentConfig'))
      if (storedState == null) {
        setInitialLocalStorageStates(country, allowCookie, showConsentBar)
      }
      let gdprSessionStorageState = window.sessionStorage.getItem('allowGtm')

      if (gdprSessionStorageState == 'true') {
        loadGTMOptimized('TDN6QG5')
      }

      createCustomEventToCheckLocalStorageChanges()
      window.addEventListener(
        'storage',
        () => {
          let gdprSessionStorageState = window.sessionStorage.getItem('allowGtm')
          if (gdprSessionStorageState == true) {
            loadGTMOptimized('TDN6QG5')
          } else {
            return
          }
        },
        false
      )
    })
    events.forEach(event => document.removeEventListener(event, loadThirdPartyScripts, { passive: true }));
  };
  events.forEach(event => document.addEventListener(event, loadThirdPartyScripts, { passive: true }));
};

//revenue hero code
function executeRevenueHeroScript() {
  var targetFormIds = [
    `517ebc0a-e3b2-48e7-994d-19507b711e00`,
    `c169c509-7422-4098-bdd2-085a67d82092`,
    `e23ab1ed-02c7-42c1-90bc-ecd78ae786c3`,
    `3ba0360d-0fb0-4473-84c9-a7362657431c`,
    `568567fd-2abb-43a4-b030-a6e2d7875387`,
  ]
  if (typeof window === 'undefined') return
  if (window.addEventListener) {
    window.addEventListener('message', handleFormSubmitEvent, false)
  } else if (window.attachEvent) {
    window.attachEvent('onmessage', handleFormSubmitEvent)
  }
  function handleFormSubmitEvent(event) {
    if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
      var submittedData = event.data.data.submissionValues
      var formId = event.data.id
      console.log(formId)
      // Check if the submitted form's ID is in the targetFormIds array
      if (targetFormIds.includes(formId)) {
        var formValues = event.data.data.submissionValues
        //replace routerID with the router ID you've setup
        const RevenueHero = window.RevenueHero
        const hero = new RevenueHero({ routerId: `1226` })
        hero.submit(formValues).then((sessionData) => {
          hero.dialog.open(sessionData)
        })
      }
    }
  }
}

//default id for english site
let setID = `TDN6QG5`


// This function is now replaced by checkCountryOptimized in thirdPartyOptimizer.js
// const checkCurrCountry = checkCountryOptimized

const createCustomEventToCheckLocalStorageChanges = () => {
  var evt = document.createEvent('StorageEvent')
  evt.initStorageEvent('storage', false, false, 'allowGtm', 'oldValue', 'newValue', null, window.localStorage)
  window.dispatchEvent(evt)
}

const setInitialLocalStorageStates = (...args) => {
  const [country, allowCookie, showConsentBar] = args
  let initialObj = JSON.stringify({
    showConsentBar: showConsentBar,
    allowCookie: allowCookie,
    country: country,
  })
  localStorage.setItem('cookieConsentConfig', initialObj)
  sessionStorage.setItem('allowGtm', 'false')
  console.log('run', initialObj)
}

exports.wrapRootElement = ({ element }) => {
  return <IsMobileProvider>{element}</IsMobileProvider>
}
